import { getClientConfig } from "../../config/clientConfig";
import  AlertMessage  from "../../Components/AlertMessage/AlertMessage"; // adjust path

type ResetPasswordPayload = {
  userId: string;
  password: string;
};

const clientConfig = getClientConfig();

export const resetPassword = async (data: ResetPasswordPayload) => {
  try {
    const res = await fetch(
      `${clientConfig.backend_url}/Account/Resetpassword`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    );

    const resData = await res.json();

    if (!res.ok) {
      
      
      throw new Error(resData?.message || "Failed to reset password");
    }

    return resData;
  } catch (error: any) {
    console.error("Reset password error:", error);
    
    throw error;
  }
};
